import { ref, watch } from 'vue'

export type Mode = 'platform' | 'standalone'

const STORAGE_KEY = 'connect-api-key'

export const SERVER_ENDPOINT = (import.meta.env?.VITE_SERVER_ENDPOINT ?? '/api').replace(/\/$/, '')

const loadKey = (): string => {
  try {
    return localStorage.getItem(STORAGE_KEY) ?? ''
  } catch {
    return ''
  }
}

export const modeStore = ref<Mode | null>(null)
export const apiKey = ref<string>(loadKey())

watch(apiKey, (value) => {
  try {
    if (value) localStorage.setItem(STORAGE_KEY, value)
    else localStorage.removeItem(STORAGE_KEY)
  } catch {}
})

export const get_mode = async (): Promise<Mode> => {
  const base = SERVER_ENDPOINT.replace(/\/api$/, '')
  const res = await fetch(`${base}/status/version`, { headers: { Accept: 'application/json' } })
  const body = res.ok ? await res.json() : {}
  const mode: Mode = body?.mode === 'standalone' ? 'standalone' : 'platform'
  modeStore.value = mode
  return mode
}

export const standalone = () => modeStore.value === 'standalone'

export const signIn = (key: string) => {
  apiKey.value = key.trim()
}

export const signOut = () => {
  apiKey.value = ''
}
